import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export const notEmailField = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const isEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value);
    return !isEmail ? null : { notEmailField: true };
  };
};
